module.exports = __webpack_public_path__ + "img/ÅseLjones-JohnMcQueen-MarianBijlenga-EthelStein-WendyWahl.5ece1e02.jpg";